"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morro-d-alba": {
    "47dd8007": [{
      "hkey": "8749b9b7",
      "slug": "santa-maria-del-fiore",
      "name": "Santa Maria del Fiore",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "8749b9b7",
      "slug": "santa-maria-del-fiore",
      "name": "Santa Maria del Fiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;